import { Component } from '@angular/core';
import {ViewController } from 'ionic-angular';
import { AppData } from '../../providers/app-data';
import { MapData } from '../../providers/map-data';
import { SymbolData } from '../../providers/symbol-data';

@Component({
    selector: 'options',
    templateUrl: 'options.html'
})
export class OptionsPage {

    constructor(public viewCtrl: ViewController, private appData: AppData, private mapData: MapData, private symbolData: SymbolData) {

    }

    ngOnInit() {
        this.appData.CombinedFeatureLayers.forEach((fl) => {
            fl.legendItems = this.getLegendItems(fl);
        });
    }

    applyFilters() {
        this.dismiss();
    }

    getBasemapText(basemap:string): string {
        return basemap.substring(0,1).toUpperCase() + basemap.substring(1);
    }

    isBasemapSelected(basemap: string): boolean {
        return basemap == this.appData.selectedBasemap;
    }

    getLegendItems(layer:any) {
        if (layer.renderer.uniqueValueInfos) {
            return layer.renderer.uniqueValueInfos.map((item)=>
            {
               return {'label': item.value, 'color': this.symbolData.getHexColor(item.symbol.color)};
            });
        }
        if (layer.renderer.classBreakInfos) {
            return layer.renderer.classBreakInfos.map((item)=>
            {
               return {'label': item.minValue + ' - ' + item.maxValue, 'color': this.symbolData.getHexColor(item.symbol.color)};
            });
        }
    }

    setBasemap() {
        this.mapData.setBasemap();
    }

    setRoadwayLayer() {
         this.appData.RoadLayers.forEach((layer)=> {
            layer.visible = false;
         });
         if (typeof this.appData.selectedRoadwayLayer === 'object') {
            this.appData.selectedRoadwayLayer.visible = true;
         }
         this.mapData.refreshRoadwayLayerVisibility();
    }

    swipe(){
        this.mapData.zoomToCurrentLocation();
    }

    dismiss(data?: any) {
        // using the injected ViewController this page
        // can "dismiss" itself and pass back data
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/options/options.ts